import * as React from 'react'

import Loading from 'modules/core/components/Loading'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import CustomFieldsComponent from 'modules/custom_resources/components/CustomFields'
import customFieldsGroupCollection from 'modules/custom_resources/store/collections/customFields/byGroup'
import { FieldTypes } from 'modules/custom_resources/store/collections/customFields/fields'
import ResourceFieldsCollection from 'modules/custom_resources/store/collections/customFields/resourceFields'
import CustomField from 'modules/custom_resources/store/models/customFields/Field'

type Data = Record<string, number | string>

export const CustomFields = () => {
  const { company } = useCurrentSession()

  const resourceFieldCollection = React.useRef(
    new ResourceFieldsCollection([], {
      model_ref: 'company',
      instance_id: company.id,
    })
  ).current

  const { loading } = useAsyncData(() => {
    return Promise.all([
      customFieldsGroupCollection.byUsageGroup([CustomField.UsageGroups.employeeQuestions]),
      resourceFieldCollection.byUsageGroup([CustomField.UsageGroups.employeeQuestions]),
    ])
  }, [])

  const createCustomField = (data: Data) =>
    customFieldsGroupCollection.createForGroup(CustomField.UsageGroups.employeeQuestions, data)

  const createResourceField = (data: Data) =>
    resourceFieldCollection.createByGroup(CustomField.UsageGroups.employeeQuestions, data)

  if (loading) return <Loading />

  return (
    <CustomFieldsComponent
      canDeleteCustomField
      customFields={customFieldsGroupCollection.models}
      resourceFields={resourceFieldCollection.models}
      createCustomField={createCustomField}
      createResourceField={createResourceField}
      illustration="input-field"
      modalIllustration="pencil"
      modalLabel={i18n.t('settings.custom_fields.new.labels.title')}
      modalPlaceholder=""
      modalButton={i18n.t('settings.custom_fields.new.submit')}
      emptyMessage={i18n.t('settings.custom_fields.blank_slate.description')}
      title={i18n.t('settings.custom_fields.title')}
      description={i18n.t('settings.custom_fields.title')}
      addQuestionLabel={i18n.t('settings.custom_fields.create')}
      allowPermissions
      hideCustomResourceAssignment
      allowedFieldTypes={[
        FieldTypes.text,
        FieldTypes.cents,
        FieldTypes.money,
        FieldTypes.date,
        FieldTypes.longText,
        FieldTypes.singleChoice,
      ]}
    />
  )
}
